import { render, staticRenderFns } from "./TechnicalCompetencies.vue?vue&type=template&id=69766aec"
import script from "./TechnicalCompetencies.vue?vue&type=script&lang=js"
export * from "./TechnicalCompetencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports